import React, { useContext, useEffect, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { LessonMode } from '../../../Constants';
import { AlchemieInteractiveFrame } from 'alchemie-activity-frame';
import Guideline from '../tools/Guideline';
import HtmlComponent from '../HtmlComponent';
import OptionalImage from '../OptionalImage';
import useStyleEvents from '../../../hooks/useStyleEvents';
import PrintQuestionNumber from './PrintQuestionNumber';
import '../../../css/StandAloneAlchemieItem.scss';
import UtilsService from '../../services/UtilsService';
import responseService from '../../services/ResponseService';

const StandaloneAlchemieItem = observer(({ lessonElementId }) => {
  const {
    lessonManager,
    responseManager,
    toolbarManager,
    userManager
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const textBody = model.questionText || '';
  const [shouldRenderFrame, setShouldRenderFrame] = useState(false);
  const lessonElementState = responseManager.getLessonElementState(lessonElementId);
  const isSubmitted = !!lessonElementState?.isSubmitted;
  const readOnly = lessonManager.isReadOnly
    || !!lessonElementState?.readOnly
    || isSubmitted;
  if (!lessonElementState) {
    return (<div className='standalone-alchemie-item' />);
  }

  useStyleEvents(lessonElementId);
  let startString = '';
  let goal = '';

  if (!UtilsService.isNullOrEmpty(lessonElementState.currentResponseAnswer.goal)){
    goal = lessonElementState.currentResponseAnswer.goal;
  }

  if (!UtilsService.isNullOrEmpty(model.startCode)) {
    startString = model.startCode;
  }

  let params = {};
  if (!UtilsService.isNullOrEmpty(model.config)) {
    try {
      params = JSON.parse(model.config);
    } catch (e) {
      console.error('Failed to parse config JSON:', e);
    }
  }

  if(!UtilsService.isNullOrEmptyOrUndefined(goal)) {
    params.loadedConfig = goal
  }

  if(readOnly) {
    params.readOnly = true;
  } else {
    params.readOnly = false;
  }

  if (!UtilsService.isNullOrEmptyOrUndefined(userManager.userId)) {
    params.userId = userManager.userId;
    console.log('StandaloneAlchemieItem userId added to params', params.userId, params);
  }

  useEffect(() => {
    setShouldRenderFrame(false);
    responseService.clearInteractiveMessageSession(lessonElementId);
    const timer = setTimeout(() => {
      setShouldRenderFrame(true);
    }, 40);
    return () => {
      clearTimeout(timer);
      responseService.flushBufferedInteractiveMessage(lessonElementId);
      responseService.clearInteractiveMessageSession(lessonElementId);
    };
  }, [lessonElementId, lessonManager.currentLessonElementId, readOnly, isSubmitted]);

  const updateMessage = (e) => {
    const state = responseManager.getLessonElementState(lessonElementId);
    if (!state || lessonManager.isReadOnly || state.readOnly || state.isSubmitted) {
      return;
    }
    if (e.data.type === 'configuration') {
      responseService.holdInteractiveMessage(lessonElementId, e.data.configuration);
    }
  };

  return (
    <div  className='standalone-alchemie-item-question'>
      {toolbarManager.isGuidelineOpen && <Guideline lessonElementId={lessonElementId} />}
      <div className='test-item-question standalone-alchemie-item'>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && <PrintQuestionNumber model={model} />}
        <HtmlComponent htmlStr={textBody} />
      </div>
      <OptionalImage model={model} runtime={true} />
      <div className='test-item-answers'>
        <div className='alchemieToolWrapper'>
          { shouldRenderFrame && <AlchemieInteractiveFrame
            key={`${lessonElementId}-${readOnly}`}
            frameClass=''
            onInteractiveMessage={updateMessage}
            size='large'
            src={model.alchemieUrl}
            start={startString}
            params={params}
          /> }
          {readOnly && <div className='alchemieReadOnlyOverlay' role='presentation' />}
        </div>
      </div>
    </div>
  );
});

export default StandaloneAlchemieItem;
